import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'visits',
    templateUrl: './visits.html',
    standalone: false,
})
export class VisitsComponent implements OnInit {
    @Input() title?: string;
    @Input() visits: string = '0';
    @Input() totalVisits: string = '0';
    @Input() removeNumber?: boolean;

    visitsNumber: number = 0;
    totalVisitsNumber: number = 0;
    progress: number = 0;
    randomId: string = '';

    ngOnInit (): void {
        this.activate();
    }

    private activate (): void {
        this.visitsNumber = parseInt(this.visits);
        this.randomId = this.guidGenerator();
        this.totalVisitsNumber = parseInt(this.totalVisits);
        this.progress = 0;

        if (this.totalVisitsNumber > 0) {
            this.progress = (this.visitsNumber / this.totalVisitsNumber) * 100;
        }

        if (this.progress > 100) {
            this.progress = 100;
        }

        if (this.progress < 0) {
            this.progress = 0;
        }
    }

    private guidGenerator (): string {
        const S4 = (): string => {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        };
        return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4());
    }
}
